module.exports = __webpack_public_path__ + "img/20210430_110657.019b5dc7.jpg";